import script from "./PhotoConsultationList.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoConsultationList.vue?vue&type=script&setup=true&lang=js"

import "./PhotoConsultationList.vue?vue&type=style&index=0&id=e5d829fe&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5d829fe"]])

export default __exports__